<template>
<!-- 20190911同人攻略迁移至资讯，v4和doujin数据共用本组件展示，增加字段匹配 -->
    <div class="igc-v4-news"
        :style="{ 'background': mColor(7) }"
        @click="to" v-dmp="{action:'click,pop', targetid: item.iId||item.iNewsId||item.articleId, targettype: 'news', title: item.sTitle||item.articleTitle, from: item.iBiz?'v4':'doujin'}">
        <div class="ig--info">
            <div class="ig--title" :style="{ 'color': mColor(1) }">{{ item.sTitle||item.articleTitle }}</div>
            <div class="ig--desc" :style="{ 'color': mColor(3) }">
                <sui-icon :fill="mColor(3)"
                    name="eye-outline"></sui-icon>
                {{ item.iTotalPlay||item.totalPV | mcFormatNumber }}
            </div>
        </div>
        <sui-image :src="mImageView(item.sIMG||item.imgUrl, '/1/w/315/h/210')"></sui-image>
    </div>
</template>

<script>
import mCore from '../../scripts/mixins/core'

export default {
    name: 'igc-v4-news',

    mixins: [mCore],

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    methods: {
        to() {
            let id = this.item.iId || this.item.iNewsId || this.item.articleId

            /* #region 埋点 */
            this.mEventTracking('list_news', '列表_资讯', {
                id
            })
            // this.mEventTrackingToDMP({
            //     action: 'click',
            //     sourceid: id,
            //     targetid: id,
            //     targettype: 'article',
            //     tag: '',
            //     title: this.item.sTitle
            // })
            /* #endregion */

            this.$router.push({
                name: this.item.sIMG?'detail-news':'doujin-detail-article',
                params: {
                    id
                }
            })
        }
    }
}
</script>

<style lang="postcss">
.igc-v4-news {
    display: flex;
    box-sizing: border-box;
    overflow: hidden;
    height: 224px;
    margin-top: 20px;
    padding: 20px;
    @media (orientation: portrait) {
        width: 100%;
    }
    @media (orientation: landscape) {
        width: calc((100% - 20px) / 2);
    }
    .ig--info {
        flex: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
        .ig--title {
            display: -webkit-box;
            /* autoprefixer: ignore next */
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            font-size: 32px;
        }
        .ig--desc {
            display: flex;
            align-items: center;
            font-size: 24px;
            .sui-icon {
                width: 36px;
                height: 36px;
                margin-right: 6px;
            }
        }
    }
    .sui-image {
        flex: none;
        width: 210px;
        height: 140px;
        margin-left: 20px;
    }
}
</style>
